<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">업무현황관리</h2>
          <article>
            <ul class="search_filter">
              <li class="w50">
                <p>신청일자</p>
                <Datepicker v-model="searchInfo.startDate"  :defaultDate="searchInfo.startDate" /> 
                ~
                <Datepicker v-model="searchInfo.endDate"  :defaultDate="searchInfo.endDate" /> 
              </li>
              <li>
                <p style="width:250px">처방명/약속상품명</p>
                <input type="text" v-model="searchInfo.prescribe_nm" placeholder="처방명/약속상품명을 입력하세요" class="form_control">
              </li>
              <li class="w50">
                <p>한의원명</p>
                <input type="text" v-model="searchInfo.clinic_nm" placeholder="한의원명을 입력하세요" class="form_control"> 
              </li>
              <li>
                <p style="width:250px">환자명</p>
                <input type="text" v-model="searchInfo.patient_nm" placeholder="환자명을 입력하세요" class="form_control">
              </li>
              <li>
                <p>처리상태</p>
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio"  value="" v-model="searchInfo.pharmacy_status" @change="fn_paging_init">
                  <label for="radio1">전체</label>
                </div>  
                <div class="form_radio">
                  <input type="radio" id="radio2" name="radio"  value="P1" v-model="searchInfo.pharmacy_status" @change="fn_paging_init">
                  <label for="radio2">조제접수</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio3" name="radio" value="P2" v-model="searchInfo.pharmacy_status" @change="fn_paging_init">
                  <label for="radio3">조제중</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio4" name="radio" value="P3" v-model="searchInfo.pharmacy_status" @change="fn_paging_init">
                  <label for="radio4">탕전중</label>
                </div>   
                <div class="form_radio">
                  <input type="radio" id="radio6" name="radio" value="P5" v-model="searchInfo.pharmacy_status" @change="fn_paging_init">
                  <label for="radio6">포장중</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio8" name="radio" value="P6" v-model="searchInfo.pharmacy_status" @change="fn_paging_init">
                  <label for="radio8">배송준비</label>
                </div>                
                <div class="form_radio">
                  <input type="radio" id="radio8" name="radio" value="P7" v-model="searchInfo.pharmacy_status" @change="fn_paging_init">
                  <label for="radio8">배송중</label>
                </div>                               
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="excelDown">배송다운로드</button>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="list no_view">
              <colgroup>
                <col width="15%">
                <col width="15%">
                <col width="20%">
                <col width="15%">
                <col width="15%">
                <col width="10%">
                <col width="10%">
                <col width="5%">
              </colgroup>
              <thead>
                <tr>
                  <th>신청일자</th>
                  <th>주문번호</th>
                  <th>처방명</th>
                  <th>한의원명</th>
                  <th>환자명</th>
                  <th>상태</th>
                  <th>출력</th>
                  <th>초기화</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="pharmacyList.length == 0">
                    <td colspan="7"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in pharmacyList" :key="index">
                  <td><span>{{ item.payment_complete_dt }}</span></td>
                  <td><span>{{ item.order_code }}</span></td>
                  <td class="al"><span>{{ item.prescribe_nm }}</span></td>
                  <td><span>{{ item.clinic_nm }}</span></td>
                  <td><span>{{ item.patient_nm }}</span></td>
                  <td><span>{{ item.work_status_nm }}</span></td>
                  <td>
                    <div class="form_inline">
                      <button :class="'bdge bd_white'" @click="fn_print_modal_open(item.prescribe_seq, item.prescribe_type)">처방전</button>
                    </div>
                  </td>
                  <td>
                    <div class="form_inline" v-if="item.work_status != 'P1' && !(item.prescribe_type == 'P' && item.work_status == 'P5')">
                      <button :class="'bdge bd_red'" @click="fn_work_cancel(item)">초기화</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="fn_move_pharmacy" v-show="pagingShow"/>
          </div>
        </section>
      </div>
      <workingModal 
        :title="'조제신청서'"
        :prescribe_seq="selectPrescribeSeq" 
      />
      <promisePrescriptModal
          :title="'조제신청서'"
          :prescribe_seq="selectPrescribeSeq"
      />
    </div>
</template>

<script>
  import axios from 'axios'  
  import Pagination from "@/components/AdminPagination.vue"
  import Datepicker from '@/components/Datepicker.vue'
  import workingModal from "@/modal/admin/workingModal.vue"
  import promisePrescriptModal from "@/modal/admin/promisePrescriptModal.vue"
  import commonUtil from "@/mixin/commonUtil";
  import * as XLSX from 'xlsx'

  export default {
    name: 'pharmacyMngt',
    mixins: [commonUtil],
    components: {    
      Pagination,
      Datepicker,
      workingModal,
      promisePrescriptModal
    },
    data() {
      return {
        searchInfo : {
          startDate : '',
          endDate : '',
          prescribe_nm : '',
          pharmacy_status : '',
          clinic_nm : '',
          patient_nm : '',
          pageInfo : {
            page : 1,
            pageSize : 10,
            totPage : 0
          }                
        },
        pagingShow : false,
        pharmacyList: [],
        selected: null,
        selectPrescribeSeq : 0,
        excel: [],
      }
    },
    mounted(){
      //오늘 날짜구하기
      this.searchInfo.startDate =  this.getAddMonthDate(-1);
      this.searchInfo.endDate = this.getCurrentDate();
      this.fn_search();
    },
    methods : {
      fn_search(){
        console.log("@@@ search : %o",this.searchInfo);
        axios
            .post("/api/admin/work/getWorkStatusList", this.searchInfo)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                this.pharmacyList = res.data.workStatusList;

                console.log("@@@@ pharmacyList : %o",this.pharmacyList);

                this.searchInfo.pageInfo.totPage = res.data.totCnt;
                
                if(this.searchInfo.pageInfo.totPage> 0){
                    this.pagingShow = true;                          
                }                        

            })
            .catch((err) => console.log(err));
        },
      fn_paging_init(){
        this.searchInfo.pageInfo.page = 1;
      },
      fn_move_pharmacy(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
      },

      fn_print_modal_open(prescribe_seq, prescribe_type){
        this.selectPrescribeSeq = prescribe_seq;

        this.$nextTick(() => {
           if(prescribe_type != 'P'){
             this.$bvModal.show("workingModal");
           }else{
             this.$bvModal.show("promisePrescriptModal");
           }
        });

      },
      fn_work_cancel(item){
        
        let param = {prescribe_seq : item.prescribe_seq}

        axios
            .post("/api/admin/work/initPrescribeStatus", param)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                
                this.fn_search();

            })
            .catch((err) => console.log(err));
      },
      excelDown() {

        console.log("@@@@@@ this.pharmacyList : %o",this.pharmacyList);

        for (const excel of this.pharmacyList) {
          const excelLogs = {
            주문자: '',
            주문자우편번호: '',
            주문자주소: '',
            주문자연락처1: '',
            수령인: '',
            수령인우편번호: '',
            수령인주소: '',
            수령인핸드폰: '',
            수령인전화번호: '',
            배송메모: '',
          };
          excelLogs.주문자 = excel.send_nm;
          excelLogs.주문자우편번호 = excel.send_post_no;
          excelLogs.주문자주소 = excel.send_addr+' '+excel.send_addr_dtl;
          excelLogs.주문자연락처1 = excel.send_phone_num;
          excelLogs.수령인 = excel.receive_nm;
          excelLogs.수령인우편번호 = excel.receive_post_no;
          excelLogs.수령인주소 = excel.receive_addr+' '+excel.receive_addr_dtl;
          excelLogs.수령인핸드폰 = excel.receive_phone_num;
          excelLogs.수령인전화번호 = excel.receive_tel_num;
          excelLogs.배송메모 = excel.delivery_memo;

          this.excel.push(excelLogs);
        }

        console.log("@@@@ this.excel : %o",this.excel);
        
        // 엑셀의 workbook(엑셀파일에 지정된 이름)을 만든다
        const wb = XLSX.utils.book_new();
        //엑셀 워크시트로 json 내보내기, 배열만 가능
        const dataWS = XLSX.utils.json_to_sheet(this.excel);
        // workbook에 워크시트 추가, 시트명은 'peopleData'
        XLSX.utils.book_append_sheet(wb, dataWS, 'deliveryData');
        // 엑셀 파일을 내보낸다. 엑셀 파일 저장명은 'people.xlsx'
        XLSX.writeFile(wb, 'deliveryData.xlsx');

      },
    }
  }
</script>
